<template>
  <div class="row m-0">
    <div class="col-12">
      <h1 class="title font-weight-bold text-uppercase">
        Pagamento cotação ({{ this.$route.params.id }}) - via pix boleto bancario
      </h1>
      <hr class="linha-amarela" />
    </div>
    <div class="col-12">
      <h1 v-if="response.status == 'paid'" class="font-weight-bold text-uppercase color-success">Pagamento realizado com sucesso</h1>
    </div>
    <div :class="response.status == 'pending' ? 'card col-12 mb-5 qrStyle' : 'd-none'" style="width: 50vw; height: 42vh;">
      <div class="card-body d-flex justify-content-center align-items-center">
        <h3 v-if="response.bank_slip.digitable_line">{{ response.bank_slip.digitable_line }}</h3>
        <h3 v-else>Não foi possivel identificar um boleto.</h3>
      </div>
      <div class="card-footer text-center">
        <b-button class="btn-success mb-2 mr-4" @click="copyToClipboard()">Clique aqui para copiar</b-button>
        <b-button class="btn-success mb-2" @click="openBB()">Abrir boleto</b-button>
        <b-button class="btn-info mb-2 ml-4" @click="$bvModal.show('modal-payment-pedido')">Já realizei o pagamento</b-button>
        <div class="col-12">
          <span class="mt-4" v-if="copy">{{ this.copy }}</span>
        </div>
      </div>
    </div>
    <b-modal 
      id="modal-payment-pedido"
      title="Aguardando confirmação do pagamento"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row redirectPaymentStatus">
        <h4>Seu pedido será enviado ao lojista assim que seu pagamento for reconhecido.</h4>
        <span class="textPayment">Boleto pode demorar até 3 dias para ser aprovado</span>
      </div>
      <button class="btn btn-success btn-block" @click.prevent="redirectPayment()">Ok</button>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';

  export default {
    data() {
      return {
        copy: '',
        response: [],
      }
    },
    mounted() {
      this.loadQuote();
    },
    computed: {
    ...mapState({
      cotacao: (state) => state.cotacao,
      dadosUsuario: (state) => state.dadosUsuario,
      invoices: (state) => state.invoices
    })
  },
    methods: {
      copyToClipboard() {
        navigator.clipboard.writeText(this.value);
        this.copy = 'Copiado com sucesso!'
      },
      openBB() {
        window.open(`${this.response.secure_url}.pdf`, '_blank')
      },
       redirectPayment() {
        this.$store.dispatch('startLoader');
        this.$store.dispatch('emptyCotacao')
        .then(() => {
          const value = {
            id: this.response.id
          };
          this.$store
            .dispatch('alterStatusPayment', value)
            .then(() => {
              setTimeout(() => {
                this.$router.push({ name: 'cliente-aguardando-pagamento' });
              }, 1000);
            })
            .catch(() => {
              this.$store.dispatch('endLoader');
            })
            .finally(() => this.$store.dispatch('endLoader'));
        });
      },
      loadQuote() {
        this.$store.dispatch('startLoader');
        this.$store.dispatch('emptyCotacao').then(() => {
          setTimeout(() => {
                                const value = {
          id: this.$route.params.id,
          shop: this.$route.params.id_shop
        };
          this.$store
            .dispatch('showCheckout', value)
            .then((data) => {
              const response = data.data;
              this.value = response.bank_slip.digitable_line;
              this.response = response;
            })
            .catch(() => {
              this.$store.dispatch('endLoader');
            })
            .finally(() => this.$store.dispatch('endLoader'));
          })
        });
      },
    }
  }
</script>
<style scoped>
.color-success {
  color: rgb(237, 118, 70);
}
.color-success {
  color: rgb(237, 118, 70);
}
.redirectPaymentStatus {
  padding: 20px 40px;
  text-align: center;
}
.textPayment {
  width: 100%;
  color: red;
  font-size: 12px;
  text-align: center;
}

</style>